module.exports = __webpack_public_path__ + "static/media/npc-female.dbabc5cf.png";